import * as React from 'react';

import Button from 'components/Button';
import Row from 'components/Row';
import Text from 'components/Text';
import { TranslationPreviewIntentMenu } from 'translations/components/TranslationPreviewIntentMenu';
import { Intent } from 'translations/types';
import 'translations/components/styles/TranslationPreview.scss';

type Props = {
  displayEditingOptions: boolean;
  languageTitle: string;
  activeIntent: Intent;
  intentMenuOpen: boolean;
  noTranslationExists: boolean;
  updateIntent: (newIntent: Intent) => void;
  toggleIntentMenuOpen: () => void;
  onClose: () => void;
};

function TranslationPreviewHeader({
  displayEditingOptions,
  noTranslationExists,
  languageTitle,
  activeIntent,
  intentMenuOpen,
  updateIntent,
  toggleIntentMenuOpen,
  onClose,
}: Props) {
  return (
    <Row size="medium">
      <div className="TranslationPreview-header-row">
        <div className="TranslationPreview-header-text">
          <Text size="medium" lineHeight="xlarge" color={noTranslationExists ? 'black' : 'inherit'}>
            {languageTitle + ' '}
          </Text>
          {displayEditingOptions && (
            <TranslationPreviewIntentMenu
              activeIntent={activeIntent}
              selectIntent={updateIntent}
              menuOpen={intentMenuOpen}
              toggleMenuOpen={toggleIntentMenuOpen}
            />
          )}
        </div>
        <Button
          size="small"
          fontSize="xxsmall"
          data-test-selector={'translation-preview-close-button'}
          onClick={onClose}>
          Back
        </Button>
      </div>
    </Row>
  );
}

export { TranslationPreviewHeader, Props };
